<script>
	// NPM Modules
	import Link from 'svelte-navaid/Link.svelte';
	import { navigate } from 'svelte-navaid';
	// Stores
	import SportStore from '@/Stores/Sport/SportStore.js';
	import UrlStore from '@/Stores/UrlStore.js';
	// Components
	import FontIcon from '@/Components/FontIcon.svelte';
	import CheckBox from '@/Components/CheckBox.svelte';
	import SelectInput from '@/Components/SelectInput.svelte';

	SportStore.getSports(true);

	$: expandedSports = parseExpandedSports();
	$: $UrlStore && $UrlStore.params.get('sport');
	$: currentLocation = document.location && document.location.search;

	function parseExpandedSports() {
		if (!$UrlStore.params.has('expanded')) {
			return [];
		}
		const urlExpandedSports = $UrlStore.params.get('expanded').split(/[, ]+/);
		let expandedSports = [];
		for (const expandedSportId of urlExpandedSports) {
			if (parseInt(expandedSportId)) {
				expandedSports.push(parseInt(expandedSportId));
			}
		}
		return expandedSports;
	}

	function selectedSport(id) {
		return parseInt($UrlStore.params.get('sport')) === parseInt(id);
	}

	function selectedCompetition(id) {
		return parseInt($UrlStore.params.get('comp')) === parseInt(id);
	}

	function toggleSport(sportId) {
		if (expandedSports.includes(parseInt(sportId))) {
			expandedSports = expandedSports.filter((expandedSport) => {
				return expandedSport !== parseInt(sportId);
			});
			expandedSports = [...expandedSports];
			if (expandedSports.length > 0) {
				navigate(`/sport?sport=${parseInt($UrlStore.params.get('sport'))}&expanded=${expandedSports}`);
			} else {
				navigate(`/sport?sport=${parseInt($UrlStore.params.get('sport'))}`);
			}
			return;
		}
		expandedSports.push(parseInt(sportId));
		expandedSports = [...expandedSports];
		if (parseInt(sportId) !== parseInt($UrlStore.params.get('sport'))) {
			/* empty */
		}
	}

	function dropdownNavigation(e) {
		navigate(e.target.value);
	}
</script>

<div class="md:hidden flex flex-row px-2 mt-2 w-full">
	<SelectInput name="sportNavigation" className="w-full" on:change={dropdownNavigation}>
		<option value="/sport" selected={document.location.pathname == '/sport'}>Upcoming</option>
		{#each $SportStore
			.filter((sport) => {
				return (sport.competitions.data && sport.competitions.data.count()) > 0;
			})
			.sortBy('name')
			.all() as sport (sport.id)}
			<option value={`/sport?sport=${sport.id}`} selected={currentLocation == `?sport=${sport.id}`}
				>{sport.name} ({(sport.competitions.data && sport.competitions.data.count()) || '0'})</option
			>

			{#if sport.competitions.data && sport.competitions.data.count()}
				{#if sport.competitions.data.where('featured', true).count()}
					<optgroup label={sport.name + ' featured competitions'}>
						{#each sport.competitions.data.where('featured', true).sortBy('name').all() as competition (competition.id)}
							<option
								value={`/sport?sport=${sport.id}&comp=${competition.id}`}
								selected={currentLocation == `?sport=${sport.id}&comp=${competition.id}`}>{competition.name}</option
							>
						{/each}
					</optgroup>
				{/if}
				{#if sport.competitions.data.where('featured', false).count()}
					<optgroup label={sport.name + ' competitions'}>
						{#each sport.competitions.data.sortBy('name').all() as competition (competition.id)}
							<option
								value={`/sport?sport=${sport.id}&comp=${competition.id}`}
								selected={currentLocation == `?sport=${sport.id}&comp=${competition.id}`}>{competition.name}</option
							>
						{/each}
					</optgroup>
				{/if}
			{/if}
		{/each}
	</SelectInput>
</div>

<div class="hidden md:block sticky top-0 pr-1 mt-1 h-screen overflow-y-auto overflow-x-hidden">
	<Link
		href="/sport"
		class="{!$UrlStore.params.has('sport') ? 'border-primary' : 'border-gray-200'}
    block mb-1 font-semibold text-center uppercase bg-gray-200
    cursor-pointer hover:bg-gray-300 border-l-4 p-2"
	>
		Upcoming
	</Link>
	<ul class="space-y-1">
		{#each $SportStore
			.filter((sport) => {
				return (sport.competitions.data && sport.competitions.data.count()) > 0;
			})
			.sortBy('name')
			.all() as sport (sport.id)}
			<li class="w-full overflow-hidden tab">
				<CheckBox
					name={sport.id}
					checked={expandedSports.includes(sport.id)}
					hidden={true}
					on:change={() => toggleSport(sport.id)}
				/>
				<label
					class="{$UrlStore && selectedSport(sport.id) ? 'border-primary' : 'border-gray-200'}
	          block font-semibold bg-gray-200 cursor-pointer hover:bg-gray-300
	          border-l-4 py-2 px-1"
					for={sport.id}
				>
					<span class="flex flex-row justify-between items-center">
						<span class="flex flex-row items-center">
							{#if sport.icon}
								<span>
									{#key sport.icon}
										<FontIcon icon={sport.icon} className=" icon text-lg mr-1.5" />
									{/key}
								</span>
							{/if}
							{sport.name} ({(sport.competitions.data && sport.competitions.data.count()) || '0'})
						</span>
					</span>
				</label>
				{#if sport.competitions.data && sport.competitions.data.count()}
					<ul class="pl-2 overflow-y-auto text-sm tab-content">
						{#each sport.competitions.data.where('featured', true).sortBy('name').all() as competition (competition.id)}
							<li
								class="pl-2 my-1 border-l-4 hover:border-primary {$UrlStore && selectedCompetition(competition.id)
									? 'border-primary'
									: 'border-gray-200'}"
							>
								<Link
									href={expandedSports
										? `/sport?sport=${sport.id}&expanded=${expandedSports}&comp=${competition.id}`
										: `/sport?sport=${sport.id}&comp=${competition.id}`}
									class="hover:text-primary {$UrlStore && selectedCompetition(competition.id) ? 'text-primary' : ''}"
								>
									{competition.name}
								</Link>
							</li>
						{/each}
						{#if sport.competitions.data.where('featured', false).count()}
							<li class="border-2 border-b" />
							{#each sport.competitions.data.sortBy('name').all() as competition (competition.id)}
								<li
									class="pl-2 my-1 border-l-4 hover:border-primary {$UrlStore && selectedCompetition(competition.id)
										? 'border-primary'
										: 'border-gray-200'}"
								>
									<Link
										href={expandedSports
											? `/sport?sport=${sport.id}&expanded=${expandedSports}&comp=${competition.id}`
											: `/sport?sport=${sport.id}&comp=${competition.id}`}
										class="hover:text-primary {$UrlStore && selectedCompetition(competition.id) ? 'text-primary' : ''}"
									>
										{competition.name}
									</Link>
								</li>
							{/each}
						{/if}
					</ul>
				{/if}
			</li>
		{/each}
	</ul>
</div>
